export default {
  '角色列表':'Role List',
  '角色名模糊搜索':'Fuzzy search for role names',
  '新增角色':'Add New Role',
  '管理成员':'Manage Members',
  '角色名称':'Role Name',
  '角色备注':'Role Remarks',
  '身份':'Identity',
  '成员数量':'Number of Members',
  '确认要删除该角色：{roleName}？':'Are you sure you want to delete the role: {roleName}?',
  '角色类型':'Role Type',
  '请输入角色名称,仅支持中英文、数字':'Please enter a role name. Only Chinese, English characters, and numbers are supported.',
  '功能权限':'Functional Permissions',
  '移动端':'Mobile App',
  '编辑角色':'Edit Role',
  '角色名称仅支持中英文、数字':'Role names can only contain Chinese, English characters, and numbers.',
  '成功！':'Success!',
  '新增成员':'Add New Members',
  '取消全部选中':'Deselect All',
  '是否确认批量移除{length}名成员？':'Are you sure you want to remove {length} members in batch?',
  '批量移除成功':'Batch removal succeeded.',
  '是否确认移除成员{accountName}？':'Are you sure you want to remove the member {accountName}?',
  '移除成功':'Removal succeeded.',
  '请输入用户名称':'Please enter the user name.',
  '新增成员成功!':'New members added successfully!',
  '已选中{selectedCount}人':'{selectedCount} people have been selected.',

  //25-8-4
  '操作成功':'Operate successfully',
  '角色状态修改成功':'Role status modified successfully',
}    